import { DISCIPLINES } from "@/data/content";
import { useReveal } from "@/hooks/useReveal";

export function Disciplines() {
  const head = useReveal();
  return (
    <section id="disciplines" data-testid="disciplines-section" className="relative py-20 md:py-28 bg-ink-2">
      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        <div ref={head.ref} className={head.className}>
          <p className="font-mono2 text-xs uppercase tracking-[0.3em] text-emerald-bright mb-3">La culture urbaine</p>
          <h2 className="font-display font-bold text-3xl md:text-5xl tracking-tight max-w-3xl">
            Toutes les disciplines, <span className="text-mustard">un seul refuge</span>
          </h2>
          <p className="mt-5 max-w-2xl text-cream/70 leading-relaxed">
            De la danse au graff, du beatmaking au chant : explore l'histoire et les styles
            qui font vibrer la Factory. Chaque art raconte une histoire, chaque discipline libère une part de toi.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-12">
          {DISCIPLINES.map((d, i) => (
            <article
              key={d.name}
              data-testid={`discipline-${i}`}
              className="group relative rounded-2xl overflow-hidden bg-ink border border-white/5 card-hover min-h-[340px] flex flex-col justify-end"
            >
              <img
                src={d.img}
                alt={d.name}
                className="absolute inset-0 w-full h-full object-cover opacity-60 group-hover:opacity-80 group-hover:scale-105 transition-all duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/60 to-transparent" />
              <div className="relative p-6">
                <span className="inline-block tag-emerald rounded-md px-2 py-0.5 text-[10px] font-mono2 uppercase tracking-wider mb-3">{d.tag}</span>
                <h3 className="font-display font-bold text-2xl text-cream">{d.name}</h3>
                <p className="mt-2 text-sm text-cream/70 leading-relaxed">{d.text}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
